(function () {
  'use strict';
  function validate(action = {}) {
    let returnable;
    if (
      angular.isString(action.vendorId) &&
      angular.isObject(action.vendor) &&
      angular.isString(action.vendor.displayName) &&
      angular.isString(action.vendor.contactName) &&
      angular.isString(action.vendor.contactPhone) &&
      angular.isString(action.vendor.contactEmail)
    ) {
      returnable = true;
    }
    return returnable;
  }
  function reducer(action, $firedux) {
    return $firedux
      .ref('vendors')
      .child(action.vendorId)
      .child('metadata')
      .update({
        displayName: action.vendor.displayName,
        contactName: action.vendor.contactName,
        contactPhone: action.vendor.contactPhone,
        contactEmail: action.vendor.contactEmail,
        notes: action.vendor.notes || null,
        logoUrl: action.vendor.logoUrl || null
      });
  }
  angular
    .module('reducers')
    .run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'VENDOR.UPDATE',
      reducer: function (action) {
        return validate(action) ?
          reducer(action, $firedux) :
          Promise.reject('VALIDATION ERROR');
      }
    });
  }
}());
